module.exports = "/_next/static/images/64bcb470f563ea5b22ff8f1a7f2cd33a-phone-mobile.png";